module.exports = __webpack_public_path__ + "img/ht.a691e42f.svg";